import React from "react";
import {withTranslation} from "react-i18next";
import {EditGoalModal} from "../../../client/EditGoalModal";
import {COLUMN_CELL_INVALID_CONTENT} from "../../columns";
import {DashboardCell} from "./base/DashboardCell";

class DashboardGoalGoalCellClass extends DashboardCell {
    constructor(props) {
        super(props);
        this.handleGoalModified = this.handleGoalModified.bind(this);
    }

    hasGoal() {
        return this.props.data.has_goal;
    }

    renderText() {
        return this.props.data["formatted_value"];
    }

    renderEditInModalIcon() {
        // readOnly: Portal del Cliente — el objetivo es solo lectura.
        if (this.props.readOnly)
            return null;

        return <EditGoalModal onFormSubmitted={this.handleGoalModified}
                              businessUnitId={this.props.businessUnitId}
                              campaignsConfigurationId={this.props.campaignsConfigurationId}
                              campaignId={this.props.campaignId}
                              adgroupId={this.props.adgroupId}
                              priority={this.props.priority}
                              clickOutsideDontCloseModal={true}
        />
    }

    handleGoalModified(data) {
        this.props.onGoalUpdated(this.props.campaignId, this.props.adgroupId, data)
    }

    classIfHasGoal() {
        if (this.hasGoal()) {
            return "small"
        }
        return "small";
    }

    render() {
        let content = null;

        if (this.hasGoal()) {
            content = <div>{this.renderText()}</div>;
        } else {
            content = [COLUMN_CELL_INVALID_CONTENT]
        }

        const liveMetaBadge = this.renderLiveMetaIfNecessary();

        return (
            <td className={`graphic-data ${this.classIfHasGoal()} ${this.processingCssClasses()}`}>
                <div className="graphic-goals">
                    {liveMetaBadge}{content}{this.renderEditInModalIcon()}
                </div>
            </td>
        );
    }
}

export const DashboardGoalGoalCell = withTranslation()(DashboardGoalGoalCellClass);
